import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['table']

  connect () {
    if (this.enableInfiniteScroll) {
      window.addEventListener('scroll', () => { this.infiniteScroll() })
      this.tableTarget.insertAdjacentHTML('afterend', '<div id="infinite-loading" data-loading=""></div>')
      this.loadingDiv = this.tableTarget.nextElementSibling

      this.verMas(location.hash === '#mi-trader' ? '#mi-trader' : null)
    }
  }

  infiniteScroll () {
    const endOfRanking = document.querySelector('[page="last"]'),
          isPageEnd = window.pageYOffset >= this.getDocumentHeight() - (window.innerHeight * 3)

    if (endOfRanking) {
      this.loadingDiv && this.loadingDiv.remove()
      delete this.loadingDiv.dataset.loading
      delete this.loadingDiv.dataset.loading
    } else if (isPageEnd && !this.fetching) {
      this.verMas()
    }
  }

  muestraEstadisticaDesplegada (event) {
    const traderRow = event.target.closest('tr')
    if (traderRow.hasAttribute('working')) return

    traderRow.setAttribute('working', true)
    const statisticsRowSelector = `.trn-Ranking_Statistics-${traderRow.dataset.traderid}`
    const iconArrow = traderRow.querySelector('.svg-icon-caret-outline')
    const trSibling = traderRow.nextElementSibling
    const isSiblingTheStatisticsRow = trSibling && trSibling.matches(statisticsRowSelector)
    const isOpen = isSiblingTheStatisticsRow && iconArrow.classList.contains('svg-icon-rotate-270')

    if (isOpen) {
      iconArrow.classList.remove('svg-icon-rotate-270')
      iconArrow.classList.add('svg-icon-rotate-90')
      document.querySelector(statisticsRowSelector).classList.add('hidden')
      traderRow.removeAttribute('working')
    } else if (isSiblingTheStatisticsRow) {
      iconArrow.classList.remove('svg-icon-rotate-90')
      iconArrow.classList.add('svg-icon-rotate-270')
      document.querySelector(statisticsRowSelector).classList.remove('hidden')
      traderRow.removeAttribute('working')
    } else {
      iconArrow.classList.remove('svg-icon-rotate-90')
      iconArrow.classList.add('svg-icon-rotate-270')
      this.connectToJsonDatas(traderRow)
    }
  }

  //
  // Private
  //

  verMas (searchingMyTrader) {
    this.fetching =  true

    if (searchingMyTrader) {
      const loadingText = 'Buscando posición'
      delete this.loadingDiv.dataset.loading
      document.body.dataset.loading = loadingText
    }

    fetch(this.buildVerMasURL)
      .then(response => response.text())
      .then(responseText => {
        this.tableTarget.insertAdjacentHTML('beforeend', responseText)
        this.fetching =  false

        if (searchingMyTrader) {
          const miTrader = this.tableTarget.querySelector('#mi-trader')
          if (miTrader) {
            this.loadingDiv.dataset.loading = ''
            delete this.loadingDiv.dataset.loading
            scrollToNode('#mi-trader', window.innerHeight / 2)
          } else {
            delete this.loadingDiv.dataset.loading
            scrollToNode('#infinite-loading', 0)
            this.verMas('#mi-trader')
          }
        } else {
          this.loadingDiv.dataset.loading = ''
        }

        this.executePaginatedCharts()
      })
  }

  executePaginatedCharts () {
    const nuevosChartScript = this.tableTarget.querySelectorAll('tbody:last-child .trn-Ranking_EvolutionChart script')
    nuevosChartScript.forEach(script => eval(script.textContent))
  }

  getDocumentHeight () {
    const body = document.body,
          html = document.documentElement

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
  }

  getNewRowBasedOnTemplate (traderRow) {
    const template = document.querySelector('#estadistica-trader')
    const tempRow = document.createElement('tr')
    tempRow.classList.add('trn-Ranking_Statistics', `trn-Ranking_Statistics-${traderRow.dataset.traderid}`)
    tempRow.appendChild(template.content.cloneNode(true))

    return tempRow
  }

  createTraderChart (chartId, datas) {
    const config = {
      points: true,
      curve: true,
      colors: datas.score > 0 ? ['#7EB5ED'] : ['#da4a33'],
      library: { animation: { easing: 'easeOutQuart' } },
    }

    new Chartkick.AreaChart(chartId, datas.posiciones, config)
  }

  replaceData (statisticWrapper, selector, data) {
    statisticWrapper.querySelector(selector).innerHTML = data
  }

  renderDatas (traderRow, datas) {
    const tempRow = this.getNewRowBasedOnTemplate(traderRow)
    const imageWrapper = tempRow.querySelector('.trn-Ranking_UserImgWrapper')
    const chartDiv = tempRow.querySelector('#chart')

    chartDiv.id = `chart-${traderRow.dataset.traderid}`
    imageWrapper.style.background = `url(${datas.usuario_avatar}) center center no-repeat`
    imageWrapper.style.backgroundSize = 'cover'

    this.replaceData(tempRow, '.trn-Ranking_UserName', datas.nombre)
    tempRow.querySelector('.trn-Ranking_User').setAttribute('href', datas.enlace)
    this.replaceData(tempRow, '.trn-Ranking_DataScore', datas.score)
    this.replaceData(tempRow, '.trn-Ranking_DataRentabilidad', `${datas.rentabilidad}%`)
    this.replaceData(tempRow, '.trn-Ranking_DataParticipaciones', datas.participaciones)
    this.replaceData(tempRow, '.trn-Ranking_UserValue-gold', datas.oro)
    this.replaceData(tempRow, '.trn-Ranking_UserValue-silver', datas.plata)
    this.replaceData(tempRow, '.trn-Ranking_UserValue-bronze', datas.bronce)

    traderRow.insertAdjacentHTML('afterend', tempRow.outerHTML)
    this.createTraderChart(chartDiv.id, datas)
  }

  connectToJsonDatas (traderRow) {
    const url = '/ajax/trader-json/' + traderRow.dataset.traderid

    fetch(url, { method: 'GET', redirect: 'follow' })
      .then(response => response.json())
      .then(result => {
          this.renderDatas(traderRow, result)
          traderRow.removeAttribute('working')
      })
      .catch(exception => console.error('Exception on fetching data', exception))
  }

  get buildVerMasURL () {
    const url = new URL(location)

    url.pathname = `/ajax/${this.torneoPermalink}/ranking/ver-mas`
    url.searchParams.append('page', this.siguientePagina)
    return url
  }

  get enableInfiniteScroll () {
    return this.torneoPermalink != null
  }

  get torneoPermalink () {
    return this.data.get('scroll-feed')
  }

  get paginaActual () {
    return parseInt(this.data.get('pagina') || 1)
  }

  get siguientePagina () {
    this.data.set('pagina', this.paginaActual + 1)

    return this.data.get('pagina')
  }
}
